export const config = {
  url: "https://www.canva.com/design/DAFzIBFCY2Y/view",
  slideCount: 1,
  slideDuration: 5,
};
